import { DownOutlined, GlobalOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/styles'
import { momentLocaleTH, momentLocaleZH } from '@root/src/constants'
import { Dropdown, Menu, Select, Typography as Text } from 'antd'
import OrderAppLib from 'dimorder-orderapp-lib'
import moment from 'moment'
import React from 'react'

import { actions, useDispatch, useSelector } from '@/redux'
import colors from '@/style/colors'

const REACT_APP_REGION = process.env.REACT_APP_REGION || 'hk'

window.moment = moment
export default function LanguageOption(props) {
  const { position } = props
  const { Option } = Select
  const classes = useStyles(props)
  const dispatch = useDispatch()
  const currentLang = useSelector((state) => state.app.lang)
  const country = useSelector((state) => state.app?.ipInfo?.country)
  const locale = OrderAppLib.libs.createLocaleHelper({
    getCountryFromStore() {
      return country || currentLang
    },
  })
  const defaultLang = locale.getPreferredLanguageCode()
  let menuItems = []
  let optionItems = []

  const baseLangs = [
    { key: 'en-US', text: 'English' },
    { key: 'zh-HK', text: '中文(香港)' },
    { key: 'zh-TW', text: '中文(台灣)' },
    ...(REACT_APP_REGION === 'hk' ? [] : [{ key: 'th-TH', text: 'ภาษาไทย' }]),
  ]

  const isValidLang = baseLangs.some((lang) => lang.key === currentLang)
  const [selectedLang, setSelectedLang] = React.useState(isValidLang ? currentLang : 'en-US')

  // 根據 currentLang 排序，將匹配的語言移到最前面（支援前綴匹配）
  const langs = React.useMemo(() => {
    const langPrefix = defaultLang.split('-')[0] // 取得語言前綴，如 'zh', 'en', 'th'
    return [...baseLangs].sort((a, b) => {
      const aPrefix = a.key.split('-')[0]
      const bPrefix = b.key.split('-')[0]

      // 完全匹配優先
      if (a.key === defaultLang) return -1
      if (b.key === defaultLang) return 1

      // 前綴匹配次之
      if (aPrefix === langPrefix && bPrefix !== langPrefix) return -1
      if (bPrefix === langPrefix && aPrefix !== langPrefix) return 1

      return 0
    })
  }, [defaultLang])

  const handleMenuSwitchLang = (key) => {
    if (key.key === 'zh-HK') {
      moment.defineLocale('zh', momentLocaleZH)
      moment.locale('zh', momentLocaleZH)
    } else if (key.key === 'th-TH') {
      moment.defineLocale('th', momentLocaleTH)
      moment.locale('th', momentLocaleTH)
    } else if (key.key === 'zh-TW') {
      moment.defineLocale('zh', momentLocaleZH)
      moment.locale('zh', momentLocaleZH)
    } else {
      moment.locale('en')
    }
    setSelectedLang(key.key)
  }

  const onLangOptionChange = (value) => {
    if (value === 'zh-HK') {
      moment.defineLocale('zh', momentLocaleZH)
      moment.locale('zh', momentLocaleZH)
    } else if (value === 'th-TH') {
      moment.defineLocale('th', momentLocaleTH)
      moment.locale('th', momentLocaleTH)
    } else if (value === 'zh-TW') {
      moment.defineLocale('zh', momentLocaleZH)
      moment.locale('zh', momentLocaleZH)
    } else {
      moment.locale('en')
    }
    setSelectedLang(value)
  }

  React.useEffect(() => {
    dispatch(actions.app.changeLang(selectedLang))
    if (selectedLang === 'zh-HK') {
      moment.defineLocale('zh', momentLocaleZH)
      moment.locale('zh', momentLocaleZH)
    } else if (selectedLang === 'th-TH') {
      moment.defineLocale('th', momentLocaleTH)
      moment.locale('th', momentLocaleTH)
    } else if (selectedLang === 'zh-TW') {
      moment.defineLocale('zh', momentLocaleZH)
      moment.locale('zh', momentLocaleZH)
    } else {
      moment.locale('en')
    }
  }, [selectedLang, dispatch])

  menuItems = langs.map((lang) => {
    return (
      <Menu.Item key={lang.key} onClick={handleMenuSwitchLang} className={classes.menuItem}>
        <Text className={classes.optionItem}>{lang.text}</Text>
      </Menu.Item>
    )
  })

  optionItems = langs.map((lang) => {
    return (
      <Option key={lang.key} value={lang.key}>
        <Text className={classes.optionItem}>{lang.text}</Text>
      </Option>
    )
  })

  const menu = <Menu>{menuItems}</Menu>

  return (
    <>
      {position === 'header' && (
        <Dropdown overlay={menu}>
          <Text className={classes.icon}>
            <GlobalOutlined />
            <DownOutlined style={{ paddingLeft: 6 }} />
          </Text>
        </Dropdown>
      )}
      {position === 'auth' && (
        <>
          <GlobalOutlined className={classes.icon} />
          <Select value={selectedLang} onChange={onLangOptionChange} bordered={false}>
            {optionItems}
          </Select>
        </>
      )}
    </>
  )
}

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 20,
    color: colors.grey,
  },
  optionItem: {
    fontSize: 16,
  },
  menuContainer: {
    textAlign: 'left',
  },
}))
